/* lua.js generated code 0.3.0 */

require("clover/ui/UIConsts")
const Event = require("hecore/EventDispatcher").Event

var kDarkOpacity = 150
var visibleOrigin = cc.Director.getInstance().getVisibleOrigin()
var visibleSize = cc.Director.getInstance().getVisibleSize()
PopoutEvents = table(
    [1, "kRemoveOnce", "removeOnce"],
    [1, "kBecomeSecondPanel", "becomeSecondPanel"],
    [1, "kReBecomeTopPanel", "reBecomeTopPanel"]
)
PopoutManager = table()
PopoutManager.getInstance = function () {
    var self = this
    return PopoutManager
}
function getPopoutList(scene) {
    if (!scene) {
        scene = cc.Director.getInstance().getRunningScene()
    } else if (scene.isDisposed) {
        return null
    }
    if (!scene) {
        return null
    }
    if (!scene.__popoutList) {
        var popoutList = table()
        popoutList.refreshDark = function () {
            var __VA_ARG = $slice(arguments, 0)
            var self = this
            var $limit8 = $len(self)
            for (var i = 1; i <= $limit8; i += 1) {
                if (self[i].darkLayer) {
                    self[i].darkLayer.setVisible(false)
                    self[i].darkLayer.setOpacity(kDarkOpacity)
                }
            }
            var $var10 = $len(self)
            for (var i = $var10; i >= 1; i += -1) {
                if (self[i].darkLayer) {
                    self[i].darkLayer.setVisible(true)
                    break
                }
            }
        }
        popoutList.size = function () {
            let self = this
            // WARN: maybe multi result
            return table.size(self)
        }
        popoutList.getPreviousDarkContainer = function () {
            var self = this
            var $var14 = $len(self)
            for (var i = $var14; i >= 1; i += -1) {
                if (self[i].darkLayer && !self[i].darkLayer.isVisible() && !self[i].darkLayer.isRemoving) {
                    return self[i]
                }
            }
            return null
        }
        popoutList.add = function (container) {
            var self = this
            table.insert(self, container)
            if (container.child && container.child.scenePanelCount) {
                let scene = cc.Director.getInstance().getRunningScene()
                let count = scene.subPanels || 0
                scene.subPanels = count + 1
                container.scenePanelCount = container.child.scenePanelCount
            }
            self.refreshDark()
        }
        popoutList.remove = function (container) {
            var self = this
            if (container.scenePanelCount) {
                let scene = cc.Director.getInstance().getRunningScene()
                let count = scene.subPanels || 0
                scene.subPanels = Math.max(count - 1, 0)
            }
            table.removeValue(self, container)
            self.refreshDark()
        }
        scene.__popoutList = popoutList
    }
    return scene.__popoutList
}
function addContainerToScene(child, dark, enableTouchBehind, scene) {
    //test
    // enableTouchBehind = true
    cc.log("addContainerToScene " + tostring(dark))
    var popoutList = getPopoutList(scene)
    if (!popoutList) {
        return 
    }
    if (META.platform == XcloverPlatform.wechatgame) {
        var homeScene = require("clover/scene/HomeScene").getInstance();
        var homeSceneButtonBox = homeScene.btnLayer.buttonBox;
        // if(homeSceneButtonBox.gameClubButton) {
        //     homeSceneButtonBox.gameClubButton.hide()
        // } 
        var homeSceneButtonLayer = homeScene.btnLayer;
        if(homeSceneButtonLayer.gameClubButton) {
            homeSceneButtonLayer.gameClubButton.hide()
        }

        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(false)
    }
    var curScene = cc.Director.getInstance().getRunningScene()
    var container = cc.Layer.create()
    container.setAnchorPoint(cc.p(0, 0))
    container.setPosition(visibleOrigin)
    container.setContentSize(visibleSize)
    if (dark) {
        var darkLayer = cc.LayerColor.create(ccc4(0, 0, 0, 255))
        darkLayer.setOpacity(kDarkOpacity)
        darkLayer.setContentSize(visibleSize)
        container.addChild(darkLayer)
        container.darkLayer = darkLayer
    }
    if (!enableTouchBehind) {
        cc.log("add mask ===============================")
        var swallowLayer = cc.Layer.create()
        swallowLayer.setTouchEnabled(true)
        swallowLayer.setContentSize(visibleSize)
        container.addChild(swallowLayer)
        function checkClickOnPanel(touch) {
            var p = child
            var sz = p.getContentSize()
            var tp = touch.getLocation()
            if (tp.x > p.getPositionX() && tp.y < p.getPositionY() && tp.x < p.getPositionX() + sz.width * p.getScaleX() && tp.y > p.getPositionY() - sz.height * p.getScaleY()) {
                return true
            } else {
                return false
            }
        }
        var startClickOnEmpty = false
        function onTouchBegan(touch, event) {
            startClickOnEmpty = !checkClickOnPanel(touch)
            return true
        }
        function onTouchEnded(touch, event) {
            if (child) {
                child.onClickAnywhere()
            }
            if (checkClickOnPanel(touch)) {
                if (child) {
                    child.onClickPanel()
                }
            } else if (child && startClickOnEmpty) {
                child.onClickEmpty()
            }
        }

        var listener = cc.EventListenerTouchOneByOne.create()
        listener.setSwallowTouches(true)
        listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
        listener.registerScriptHandler(onTouchEnded, cc.Handler.EVENT_TOUCH_ENDED)

        //cc.log("listener add: " + listener.__instanceId)
        child._listener =  listener;
        // TODO: check
        // var eventDispatcher = swallowLayer.getEventDispatcher()
        // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, swallowLayer)

        cc.eventManager.addListener(listener, swallowLayer)
    }
    var childContainer = cc.Node.create()
    childContainer.addChild(child)
    container.addChild(childContainer)
    container.child = child
    curScene.addChild(container, UIPopoutLayoutOrder.kPanel)
    popoutList.add(container)
    container.remove = function (cleanup) {
        var self = this
        popoutList.remove(self)
        self.removeFromParent(cleanup)
    }
    container.getPopoutList = function () {
        var __VA_ARG = $slice(arguments, 0)
        var self = this
        return popoutList
    }
    return container
}
PopoutManager.add = function (child, dark, enableTouchBehind, scene) {
    var self = this
    var container = addContainerToScene(child, dark, enableTouchBehind, scene)
    if (!container) {
        return 
    }
    var poplist = container.getPopoutList()
    var popNum = $len(poplist)
    if (popNum > 1) {
        var secPanelIndex = popNum - 1
        var secPanel = poplist[secPanelIndex].child
        if (secPanel && secPanel.becomeSecondPanel) {
            secPanel.becomeSecondPanel()
        }
        if (secPanel) {
            // secPanel:dispatchEvent(Event.new(PopoutEvents.kBecomeSecondPanel, nil, secPanel))
        }
    }
}
PopoutManager.remove = function (child, cleanup) {
    var self = this
    if (child.isDisposed || !child.getParent() || !child.getParent().getParent()) {
        // warn
        return 
    }
    var container = child.getParent().getParent()
    var popoutList = container.getPopoutList()
    child.removeFromParent(cleanup)
    container.remove(cleanup)
    container.dispose()

    SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(true)
    
    if (child._listener){
        //cc.log("listener remove: " + child._listener.__instanceId)
        cc.eventManager.removeListener(child._listener)
        child._listener = null
    } 
    var lastPopoutPanel = null
    if ($len(popoutList) > 0) {
        lastPopoutPanel = table.last(popoutList).child
    }
    if (lastPopoutPanel && lastPopoutPanel.reBecomeTopPanel) {
        lastPopoutPanel.reBecomeTopPanel()
    }
    if (lastPopoutPanel) {
        // lastPopoutPanel:dispatchEvent(Event.new(PopoutEvents.kReBecomeTopPanel, nil, lastPopoutPanel))
    }
    if (!$len(popoutList)) {
        if (META.platform == XcloverPlatform.wechatgame) {
            var homeScene = require("clover/scene/HomeScene").getInstance();
            // var homeSceneButtonBox = homeScene.btnLayer.buttonBox;
            // if(homeSceneButtonBox.isOpen  && homeSceneButtonBox.gameClubButton) {
            //     homeSceneButtonBox.gameClubButton.show()
            // } 
            var homeSceneButtonLayer = homeScene.btnLayer;
            if(homeSceneButtonLayer.gameClubButton && cc.director.getRunningScene().name === "HomeScene") {
                homeSceneButtonLayer.gameClubButton.show()
            }
        }
    }
}
PopoutManager.addWithBgFadeIn = function (child, dark, enableTouchBehind, fadeInAnimFinishedCallback, duration, scene,maskOpacity) {
    if (maskOpacity){
        kDarkOpacity = maskOpacity
    }else{
        kDarkOpacity = 220
    }
    var container = addContainerToScene(child, true, enableTouchBehind, scene)
    if (!container) {
        return 
    }
    var popoutList = getPopoutList(scene)
    var fadeOutContainer = null
    if (popoutList) {
        fadeOutContainer = popoutList.getPreviousDarkContainer()
    }
    var arr = LuaArray.create()
    if (fadeOutContainer) {
        arr.addObject(cc.CallFunc.create(function () {
            if (fadeOutContainer.darkLayer) {
                fadeOutContainer.darkLayer.setVisible(true)
                container.darkLayer.setOpacity(0)
            }
        }))
        arr.addObject(cc.Spawn.create(cc.FadeTo.create(duration || 0.25, kDarkOpacity), cc.TargetedAction.create(fadeOutContainer.darkLayer, cc.FadeTo.create(duration || 0.25, 0))))
        arr.addObject(cc.CallFunc.create(function () {
            if (fadeOutContainer.darkLayer) {
                fadeOutContainer.darkLayer.setVisible(false)
                fadeOutContainer.darkLayer.setOpacity(kDarkOpacity)
            }
        }))
    } else {
        arr.addObject(cc.CallFunc.create(function () {
            container.darkLayer.setOpacity(0)
        }))
        arr.addObject(cc.FadeTo.create(duration || 0.25, kDarkOpacity))
    }
    arr.addObject(cc.CallFunc.create(function () {
        if (type(fadeInAnimFinishedCallback) === "function") {
            fadeInAnimFinishedCallback()
        }
    }))
    container.darkLayer.runAction(cc.Sequence.create(arr.toLuaArray()))
}
PopoutManager.removeWithBgFadeOut = function (child, animFinishCallback, notUsedParameter, duration) {
    var self = this
    if (child.isDisposed || !child.getParent() || !child.getParent().getParent()) {
        // warn
        return 
    }
    function onRemoveEnd() {
        if (type(animFinishCallback) === "function") {
            animFinishCallback()
        }
        if (!PopoutManager.getInstance().haveWindowOnScreen()) {
            if (HomeScenePopoutQueue !== null && HomeScenePopoutQueue.getInstance().inWait) {
                HomeScenePopoutQueue.getInstance().executor()
            }
        }
    }
    var container = child.getParent().getParent()
    if (container.darkLayer && container.darkLayer.isVisible()) {
        container.darkLayer.isRemoving = true
        var popoutList = container.getPopoutList()
        var fadeInContainer = null
        if (popoutList) {
            fadeInContainer = popoutList.getPreviousDarkContainer()
        }
        if (duration === 0) {
            if (fadeInContainer != null && fadeInContainer.darkLayer != null) {
                fadeInContainer.darkLayer.setOpacity(0);
                fadeInContainer.darkLayer.setVisible(true);
            }
            self.remove(child, true);
            onRemoveEnd();
        } else {
            var arr = LuaArray.create()
            if (!fadeInContainer) {
                arr.addObject(cc.FadeTo.create(duration || 0.25, 0))
            } else {
                arr.addObject(cc.CallFunc.create(function () {
                    var __VA_ARG = $slice(arguments, 0)
                    if (fadeInContainer.darkLayer) {
                        fadeInContainer.darkLayer.setOpacity(0)
                        fadeInContainer.darkLayer.setVisible(true)
                    }
                }))
                arr.addObject(cc.Spawn.create(cc.FadeTo.create(duration || 0.25, 0), cc.TargetedAction.create(fadeInContainer.darkLayer, cc.FadeTo.create(duration || 0.25, kDarkOpacity))))
            }
            
            arr.addObject(cc.CallFunc.create(function () {
                var __VA_ARG = $slice(arguments, 0)
                self.remove(child, true)
                onRemoveEnd()
            }))
            container.darkLayer.runAction(cc.Sequence.create(arr.toLuaArray()))
        }
    } else {
        self.remove(child, true)
        onRemoveEnd()
    }
}
PopoutManager.removeAll = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var popoutList = getPopoutList() || table()
    while ($len(popoutList) > 0) {
        self.remove(popoutList[1].child, true)
    }
}
PopoutManager.haveWindowOnScreen = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var popoutList = getPopoutList()
    return popoutList && $len(popoutList) > 0
}
PopoutManager.getLastPopoutPanel = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    if (self.haveWindowOnScreen()) {
        var popoutList = getPopoutList()
        return table.last(popoutList).child
    } else {
        return null
    }
}
PopoutManager.getChildContainer = function (child) {
    var self = this
    // WARN: maybe multi result
    return child.getParent()
}
PopoutManager.removeWhileKeepBackground = function (child) {
    var self = this
    self.remove(child)
}
PopoutManager.addChildWithBackground = function (child, bgColor, opacity) {
    var self = this
    self.add(child, true, false)
    var panelSize = child.getGroupBounds()
    var posX = 0 - (visibleSize.width - panelSize.width) / 2
    var posY = 0 - (visibleSize.height + panelSize.height) / 2
    var childPosY = 0 - (visibleSize.height - panelSize.height) / 2
    child.setPosition(ccp(-posX, childPosY))
}
PopoutManager.onTopPanelKeyback = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var panel = PopoutManager.getInstance().getLastPopoutPanel()
    if (panel && panel.onKeyBackClicked && type(panel.onKeyBackClicked) === "function") {
        panel.onKeyBackClicked()
    }
}

PopoutManager.getPopupList = function () {
    if (this.haveWindowOnScreen()) {
        let popoutList = getPopoutList();
        let result = table();
        for(let i = 1; i <= $len(popoutList); i++) {
            table.insert(popoutList[i].child);
        }
        return result;
    } else {
        return null;
    }
}
